import { Action } from '@ngrx/store';
import { UnitV2 } from '@cemex-core/cmx-api';
import { GetUnitsReq } from '@cemex-core/cmx-api/models/product/get-units-req';
import { AltUnit } from '../models/units';

export enum ProductUnitActionTypes {
  RESET = '[ProductUnits] Reset',
  LOAD_UNITS = '[ProductUnits] Load Units',
  LOAD_UNITS_COMPLETE = '[ProductUnits] Load Units Complete',
  LOAD_ALTERNATIVE_UNITS_COMPLETE = '[ProductUnits] Load Alternative Units Complete',
  SET_ACTUAL_UNITS = '[ProductUnits] Set Actual Units',
  SET_ACTUAL_UNITS_COMPLETE = '[ProductUnits] Set Actual Units Complete',
}

export class ResetUnitsAction implements Action {
  readonly type = ProductUnitActionTypes.RESET;

  constructor() {}
}

export class LoadUnitsAction implements Action {
  readonly type = ProductUnitActionTypes.LOAD_UNITS;

  constructor(public payload: { productId: number; request: GetUnitsReq }) {}
}

export class LoadUnitsCompleteAction implements Action {
  readonly type = ProductUnitActionTypes.LOAD_UNITS_COMPLETE;

  constructor(public payload: { [productId: number]: UnitV2[] }) {}
}

export class LoadAlternativeUnitsCompleteAction implements Action {
  readonly type = ProductUnitActionTypes.LOAD_ALTERNATIVE_UNITS_COMPLETE;

  constructor(public payload: { [productId: number]: AltUnit[] }) {}
}

/**
 * Unused
 */
export class SetActualUnitsAction implements Action {
  readonly type = ProductUnitActionTypes.SET_ACTUAL_UNITS;

  constructor(public payload: { productId: number }) {}
}

/**
 * Unused
 */
export class SetActualUnitsCompleteAction implements Action {
  readonly type = ProductUnitActionTypes.SET_ACTUAL_UNITS_COMPLETE;

  constructor(public payload: UnitV2[]) {}
}

export type ProductUnitActions =
  | ResetUnitsAction
  | LoadUnitsAction
  | LoadUnitsCompleteAction
  | LoadAlternativeUnitsCompleteAction
  | SetActualUnitsAction
  | SetActualUnitsCompleteAction;
